import React from 'react';

import PropTypes from 'prop-types';
import { Table, Pagination, Message, Icon } from 'semantic-ui-react';

import _isEmpty from 'lodash/isEmpty';

import { usePagination } from 'components/modules/foundation/hooks/';
import { ThemeTemplatesPropTypes } from 'components/modules/theme-templates/types';

import {
  PAGE_SIZE,
  NO_THEME_TEMPLATES_MESSAGE_TITLE,
  NO_THEME_TEMPLATES_MESSAGE_CONTENT,
  LOADING_TEMPLATES_MESSAGE_TITLE,
  LOADING_TEMPLATES_MESSAGE_CONTENT,
} from './ThemeTemplatesTable.constants';
import { ThemeTemplatesTableHeader, ThemeTemplatesTableRow } from './components';

import './ThemeTemplatesTable.scss';

const propTypes = {
  themeTemplates: ThemeTemplatesPropTypes.isRequired,
  onViewTemplate: PropTypes.func.isRequired,
  onEditTemplate: PropTypes.func.isRequired,
  onApplyTemplate: PropTypes.func.isRequired,
  loadingTemplates: PropTypes.bool,
};

const defaultProps = {
  loadingTemplates: false,
};

function ThemeTemplatesTable({
  themeTemplates,
  onViewTemplate,
  onEditTemplate,
  onApplyTemplate,
  loadingTemplates,
}) {
  const { activePage, getActivePageItems, onPageChange, totalPages } = usePagination(
    themeTemplates,
    PAGE_SIZE,
  );

  const activeThemeTemplates = getActivePageItems();

  if (_isEmpty(themeTemplates)) {
    return (
      <Message
        header={
          loadingTemplates ? LOADING_TEMPLATES_MESSAGE_TITLE : NO_THEME_TEMPLATES_MESSAGE_TITLE
        }
        content={
          loadingTemplates ? LOADING_TEMPLATES_MESSAGE_CONTENT : NO_THEME_TEMPLATES_MESSAGE_CONTENT
        }
        icon={loadingTemplates && <Icon name="circle notched" loading />}
      />
    );
  }

  return (
    <Table celled className="theme-templates-table">
      <ThemeTemplatesTableHeader />
      <Table.Body>
        {activeThemeTemplates.map((template) => (
          <ThemeTemplatesTableRow
            key={template.id}
            template={template}
            onViewTemplate={onViewTemplate}
            onEditTemplate={onEditTemplate}
            onApplyTemplate={onApplyTemplate}
          />
        ))}
      </Table.Body>
      <Table.Footer>
        <Table.Row>
          <Table.HeaderCell colSpan="5">
            <Pagination
              activePage={activePage}
              onPageChange={onPageChange}
              totalPages={totalPages}
            />
          </Table.HeaderCell>
        </Table.Row>
      </Table.Footer>
    </Table>
  );
}

ThemeTemplatesTable.propTypes = propTypes;
ThemeTemplatesTable.defaultProps = defaultProps;

export default ThemeTemplatesTable;
